export const LAST_UPDATE_METHOD = {
  stepsSidebarInteraction: 'steps-sidebar-interaction',
  backendSync: 'backend-sync',
  rowsResultPagination: 'rows-result-pagination',
  saveQuery: 'save-query',
} as const;
